(ns ui.view.card.shared-components.card-title)

(defn view
  [title]
  [:p
   {:class "text-lg font-bold text-base-light-text"}
   title])
